'use strict';
import MxEnum from '../../../../Utils/MxEnum';

export const gridEnums = {
	EditMode: new MxEnum({
		None: 0,
		Inline: 1,
		EditForm: 2,
		Wizard: 3,
		GenericEdit: 4,
	}),

	ObjectGridOnClickActions: new MxEnum({
		None: 'none',
		Preview: 'preview',
		Edit: 'edit',
	}),

	DataDefinitionGridTypes: new MxEnum({
		Objects: 0,
		Relation: 1,
		MultiFragment: 2,
	}),
};
